import AxiosInstance from "../../components/Axios";
import {useState} from "react";
import {format} from "date-fns";
import { AIInterpretRequest,  AIInterpretResponse} from "./types";

export async function interpretAIForm<T>(
  payload: AIInterpretRequest
): Promise<AIInterpretResponse<T>> {

  const response = await AxiosInstance.post(
    "ai/forms/interpret/",
    {
      form: payload.form,
      text: payload.text,
      reference_date: payload.referenceDate
    }
  );

  return response.data.data as AIInterpretResponse<T>;
}


export function useAIForm<T>(formName: string) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const interpret = async (
    text: string,
    referenceDate = new Date()
  ) => {
    setLoading(true);
    setError(null);

    try {
      return await interpretAIForm<T>({
        form: formName,
        text,
        referenceDate: format(referenceDate, "yyyy-MM-dd")
      });
    } catch (err: any) {
      const message =
        err?.response?.data?.message ||
        "Impossibile interpretare la descrizione";

      setError(message);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return {
    interpret,
    loading,
    error
  };
}
